// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Ksh2","mainWrapper":"styles_mainWrapper__RvIGy","inquiryWrapper":"styles_inquiryWrapper__jypX4"};